(function () {
  if (typeof Node.prototype.contains === 'undefined') {
    Node.prototype.contains = function (element) {
      return this === element || !!(this.compareDocumentPosition(element) & 16);
    };
  }
})();
